import { userWorkspaceManager as workspace } from "../../constants/actionTypes";

const getUserWorkspaceManagerList = (url) => ({
  type: workspace.GET_USER_WORKSPACE_DASHBOARD_LIST,
  data: url,
});

const setUserWorkspaceManagerList = (data) => ({
  type: workspace.SET_USER_WORKSPACE_DASHBOARD_LIST,
  data: data,
});

const setUserWorkspaceManagerListError = (data) => ({
  type: workspace.SET_USER_WORKSPACE_DASHBOARD_LIST_ERROR,
  payload: data,
});

const setGetUserWorkspaceListLoading = (data) => ({
  type: workspace.SET_USER_WORKSPACE_LIST_LOADING,
  payload: data,
});

const getUserWorkspaceLabTimer = (url) => ({
  type: workspace.GET_USER_WORKSPACE_LAB_TIMER,
  data: url,
});

const setUserWorkspaceLabTimer = (data) => ({
  type: workspace.SET_USER_WORKSPACE_LAB_TIMER,
  data: data,
});

const setLabCardVmStatus = (data) => ({
  type: workspace.SET_WORKSPACE_VM_STATUS,
  data: data,
});

export {
  getUserWorkspaceManagerList,
  setUserWorkspaceManagerList,
  setUserWorkspaceManagerListError,
  setGetUserWorkspaceListLoading,
  getUserWorkspaceLabTimer,
  setUserWorkspaceLabTimer,
  setLabCardVmStatus,
};
